// R-167 WU-6a — modal surfaced when DELETE /api/custom-counters/:id
// returns 409 COUNTER_IN_USE. The api response carries `references: CounterReference[]`
// listing every template-site (tenant or job-type, batch/document/page slot)
// that still references the counter via `{counter:<name>}`. Admin must
// remove the references before the counter can be deleted.
import type { CounterReference } from "../api/client";
import styles from "../counters.module.css";

export interface CounterDeleteGuardModalProps {
  counterName: string;
  references: CounterReference[];
  onClose: () => void;
}

export default function CounterDeleteGuardModal({
  counterName,
  references,
  onClose,
}: CounterDeleteGuardModalProps) {
  return (
    <div className={styles.modalBackdrop} role="dialog" aria-modal="true">
      <div className={styles.modal}>
        <h2>Cannot delete counter</h2>
        <p>
          The counter <code>{counterName}</code> is referenced by{" "}
          {references.length} template{references.length === 1 ? "" : "s"}.
          Remove the reference{references.length === 1 ? "" : "s"} below before
          deleting.
        </p>
        <ul className={styles.deleteRefList}>
          {references.map((r, i) => (
            <li key={`${r.scope}-${r.scopeId}-${r.slot}-${i}`}>
              <strong>
                {r.scope === "tenant"
                  ? "Tenant"
                  : `Job Type: ${r.scopeName}`}
              </strong>
              {" — "}
              {r.slot} template: <code>{r.template}</code>
            </li>
          ))}
        </ul>
        <div className={styles.actions}>
          <button type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
